const config = require("../config")

module.exports = {
    weatherInfo: {
        url: config.base_dev_url + "lz_weather7d/get?key=" + config.mini_key,
        type: "get",
    },
    // 专家列表
    fetchExpertList: {
        url: config.base_dev_url + "container/expertList",
        type: "get",
    },
    listByFarmIdAndContainerId: {
        url: config.base_dev_url + "container_farm_work_scheme/listByFarmIdAndContainerId",
        type: "get",
    },
    savePlan: {
        url: config.base_dev_url + "container_farm_work_scheme/save",
        type: "post",
    },
    getPhenologyFarmWorkList: {
        url: config.base_dev_url + "container_farm_work_scheme/getPhenologyFarmWorkList",
        type: "get",
    },
    fetchDiseaseDetail: {
        url: config.base_dev_url + "pest_disease_dictionary/listByIds",
        type: "post",
    },
    fetchQuestPopup: {
        url: config.base_dev_url + "work_code/phenology/quest/popup",
        type: "get",
    },
    saveQuestPopup: {
        url: config.base_dev_url + "work_code/phenology/quest/save",
        type: "post",
    },
    getExpertBySubjectId: {
        url: config.base_dev_url + "v3/farm/getExpertBySubjectId",
        type: "get",
    },
    // 查询当前农资用户的所有方案列表
    listMySchemes:{
        url: config.base_dev_url + "container_farm_work_scheme/listMySchemes",
        type: "get",
    },
    //批量初始化农事方案（多个容器）
    batchInitSchemes:{
        url: config.base_dev_url + "container_farm_work_scheme/batchInitScheme",
        type: "post",
    },
    //根据方案ID查询农事列表（按物候期分组）
    listBySchemeId:{
        url: config.base_dev_url + "z_farm_work_lib/listBySchemeId",
        type: "get",
    },
    //选择方案
    selectSchemes:{
        url: config.base_dev_url + "container_farm_work_scheme/selectSchemes",
        type: "get",
    },
    //农资弹出问卷接口
    popupByAgriculturalUserFarms: {
        url: config.base_dev_url + "work_code/phenology/quest/popupByAgriculturalUserFarms",
        type: "get",
    },
    //预警 气象 农事 专家问答 分页列表
    warningPageList: {
        url: config.base_dev_url + "bbs_post/page/{page}/{limit}",
        type: "get",
    },
    //预警 气象 详情
    warningDetail: {
        url: config.base_dev_url + "bbs_post/detail",
        type: "get",
    },
    //专家问答详情
    expertDetail: {
        url: config.base_dev_url + "bbs_post/topicDetail",
        type: "get",
    },
    //农情互动的农场列表接口（分页）
    listUnansweredFarms:{
        url: config.base_dev_url + "container_farm_work_arrange/listUnansweredFarms/{page}/{limit}",
        type: "get",
    },
    //查询未来农事预警
    listFutureFarmWorkWarning:{
        url: config.base_dev_url + "container_farm_work_arrange/futureFarmWorkWarning",
        type: "get",
    },
    //农资忽略农事库
    ignoreFarmWorkLib:{
        url: config.base_dev_url + "z_farm_work_lib/ignoreFarmWorkLib",
        type: "get",
    },
    //回答问题
    answerQuestion: {
        url: config.base_dev_url + "container_farm_work_arrange/answerQuestion",
        type: "post",
    },
    //判断是否存在可用方案
    existsEnabledScheme: {
        url: config.base_dev_url + "container_farm_work_scheme/existsEnabledScheme",
        type: "get",
    },
    //查询农场当前物候期的已触发的农情互动
    listTriggeredByFarm: {
        url: config.base_dev_url + "container_phenology_interaction/listTriggeredByFarm",
        type: "get",
    },
    //获取当前物候期和下一物候期
    getCurrentAndNextPhenology: {
        url: config.base_dev_url + "v2/farm/getCurrentAndNextPhenology",
        type: "get",
    },
    //农户上传图片、回答问题以及框选范围
    uploadAnswer: {
        url: config.base_dev_url + "container_phenology_interaction/uploadAnswer",
        type: "post",
    },
    //判断是否存在已触发但未回复的农情互动
    hasUnrepliedTriggeredInteraction: {
        url: config.base_dev_url + "container_phenology_interaction/hasUnrepliedTriggeredInteraction",
        type: "get",
    },
    //农户上传/更新互动数据（图片、指标答案、范围、回复文字等）
    uploadAnswerData: {
        url: config.base_dev_url + "container_phenology_interaction/uploadAnswerData",
        type: "post",
    },
}
